<app-links-item [color]="color" [icon]="icon" [labels]="pivot.labels" [uid]="pivot.uid">
  <div app-links-item-content-description>
  </div>
  <div app-links-item-content-option class="d-flex align-items-center">
    <app-links-item-option class="d-block mx-1" [symbol]="'eye'" [selected]="selected" (sendSelected)="receiveSelected()"></app-links-item-option>
  </div>
</app-links-item>